import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (typeof control.value === 'string' && control.value.length > 0 && control.value.trim().length === 0) {
      return { whitespace: true };
    }
    return null;
  };
}

export function requiredNoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const requiredError = Validators.required(control);
    if (requiredError) {
      return requiredError;
    }
    if (typeof control.value === 'string' && control.value.trim().length === 0) {
      return { whitespace: true };
    }
    return null;
  };
}
